module.exports = __webpack_public_path__ + "static/media/zhetysuHomeBg.84d177a6.png";